import { Link } from "react-router-dom";
import { erchuangFeature, memeItems } from "@/mocks/memes";

const highlights = memeItems.filter((item) => item.category === "erchuang");

export default function ErchuangSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto grid w-full grid-cols-1 items-center gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-2 lg:gap-14">
        <div className="w-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="w-full overflow-hidden" style={{ aspectRatio: "3 / 2" }}>
            <img
              src={erchuangFeature.src}
              alt={erchuangFeature.alt}
              title="网友二创作品 · 131吃瓜"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <div>
          <span className="text-xs tracking-[0.2em] text-secondary-700">FAN&nbsp;WORKS</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">同一张图，网友能玩出十几个版本</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            二创区是整站最热闹的地方。有人改配色，有人换台词，有人干脆把静态图做成了小动图。我们尽量保留作者的原始版本和思路说明，让好看又好用的作品被更多人看到。
          </p>

          <ul className="mt-8 space-y-4">
            {highlights.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/meme/${item.id}`}
                  className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-secondary-400"
                >
                  <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-100">
                    <img
                      src={item.cover}
                      alt={`${item.title} 二创作品封面`}
                      title={`${item.title} · 网友二创`}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="truncate font-heading text-base text-foreground-950 transition-colors group-hover:text-secondary-800">
                      {item.title}
                    </h3>
                    <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>

          <Link
            to="/category/erchuang"
            className="mt-8 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm text-primary-950 transition-colors hover:bg-secondary-600"
          >
            逛更多二创作品
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}